import { useGetServiceProfile } from 'app/hooks/requests/commerce';
import {
  OutletType,
  ServiceOutletType,
  ServiceOutletTypeKey,
} from 'app/utilities/types/shared';
import DefaultImageNoContent from 'assets/images/cuate.svg';
import { useParams } from 'react-router';
import { ElrButton } from 'ui-components';

interface UploadDashboardProps {
  outletType?: OutletType;
}

const UploadDashboard: React.FC<UploadDashboardProps> = ({ outletType }) => {
  const params = useParams();
  const serviceOutletType: ServiceOutletTypeKey = Object.values(
    ServiceOutletType
  ).includes(outletType as ServiceOutletTypeKey)
    ? (outletType as ServiceOutletTypeKey)
    : ServiceOutletType.market;

  const { serviceProfile, isLoading } = useGetServiceProfile(
    serviceOutletType,
    params.outletTypeId as string
  );

  const outletMessages: Partial<Record<OutletType, string>> = {
    market:
      'No new orders has been uploaded yet. The sales of your products will appear here.',
    restaurant:
      'No new orders has been uploaded yet. The sales of your products will appear here.',
    essentials: '',
    product: '',
    logistics: '',
  };

  return (
    <section className="bg-elr-white-400 px-12 py-8 mb-8 border-b-2 border-elr-gray w-full flex flex-col items-center">
      <div className="w-full bg-elr-gray p-8 mb-8">
        {isLoading ? (
          <p className="text-center text-lg">Loading...</p>
        ) : (
          <div className="flex w-full justify-between">
            <div className="flex flex-col gap-1 w-4/12">
              <p className="text-lg">{serviceProfile?.name || 'N/A'}</p>
              <p className="text-elr-black text-opacity-60 ">
                {serviceProfile?.address || 'N/A'}
              </p>
              <p className="text-elr-black text-opacity-60">
                {serviceProfile?.phone || 'N/A'}
              </p>
              <p className="text-elr-black text-opacity-60">
                {serviceProfile?.email || 'N/A'}
              </p>
            </div>

            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-1">
                <p className="text-elr-black text-opacity-60">Opening Time</p>
                <p>{serviceProfile?.openingTime || 'N/A'}</p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-elr-black text-opacity-60">Closing Time</p>
                <p>{serviceProfile?.closingTime || 'N/A'}</p>
              </div>
            </div>

            <div className="flex items-end">
              <ElrButton
                text="Edit Information"
                className="bg-white px-4 h-fit py-2 rounded-md"
              />
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col gap-6 mx-auto">
        <img
          src={DefaultImageNoContent}
          alt="upload-products"
          className="max-w-sm mx-auto"
        />
        <p className="text-center text-base w-7/12 mx-auto text-elr-black text-opacity-60">
          {outletType
            ? outletMessages[outletType]
            : 'No new orders have been uploaded yet. The sales of your products will appear here.'}
        </p>
      </div>
    </section>
  );
};

export default UploadDashboard;
